import { numberWithoutComma } from "../../pages/balance/component/VIDrawerDebt.Main";

export const SumVariableExpense = (addExpensesVariable) => {
  let sumVariableExpense = 0;
  addExpensesVariable?.map((row, index) => {
    /*---- ค่าอาหาร ----*/
    if (row?.options_expenses_variable === "expenses_food") {
      sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
    }


    /*---- ค่าอุปโภค ----*/
    if (row?.options_expenses_variable === "expenses_consumer") {
      sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
    }

    /*---- ค่าสาธารณูปโภค ----*/
    if (row?.options_expenses_variable === "expenses_public_utilities") {
      sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
    }

    /*---- ค่าโทรศัพท์ ----*/
    if (row?.options_expenses_variable === "expenses_mobile") {
      sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
    }

    /*---- ค่านันทนาการ ----*/
    if (row?.options_expenses_variable === "expenses_recreation") {
      sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
    }

    /*---- ภาษีบุคคลธรรมดา รายปี ----*/
    if (row?.options_expenses_variable === "expenses_tax") {
      sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
    }

    /*---- ภาษีดอกเบี้ยเงินฝาก ----*/
    if (row?.options_expenses_variable === "expenses_deposit_interest") {
      sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
    }
    
      /*---- ภาษีอัตราสารหนี้ ----*/
      if (row?.options_expenses_variable === "expenses_debt_instruments") {
        sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
      }
    
    
      /*---- ภาษีเงินปันผล ----*/
      if (row?.options_expenses_variable === "expenses_dividend") {
        sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
      }

    /*---- ภาษีรถยนต์ ----*/
    if (row?.options_expenses_variable === "expenses_tax_car") {
      sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
    }

      /*---- ภาษีอื่น ๆ ----*/
      if (row?.options_expenses_variable === "expenses_tax_other") {
        sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
      }

    /*---- ค่าน้ำมัน ----*/
    if (row?.options_expenses_variable === "expenses_gasoline") {
      sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
    }
  
    
      /*---- ค่าดูแลรักษารถยนต์ ----*/
      if (row?.options_expenses_variable === "expenses_car_maintenance") {
        sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
      }

      /*---- ค่าโดยสารรถสาธารณะ ----*/
      if (row?.options_expenses_variable === "expenses_transport") {
        sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
      }

      /*---- ค่าแม่บ้าน ----*/
      if (row?.options_expenses_variable === "expenses_maid") {
        sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
      }

      /*---- ค่ารักษาพยาบาล ----*/
      if (row?.options_expenses_variable === "expenses_medical") {
        sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
      }

      /*---- บริจาค ----*/
      if (row?.options_expenses_variable === "expenses_donate") {
        sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
      }

      /*---- ค่าใช้จ่ายอื่น ๆ ----*/
      if (row?.options_expenses_variable === "expenses_variable_other") {
        sumVariableExpense += numberWithoutComma(row?.pay_peryear||0);
      }
  
  });


  return sumVariableExpense;
};

export const SumFixedExpense = (addExpensesFixed) => {
  let sumFixedExpense = 0;
  return sumFixedExpense
}